import { useSelector } from 'react-redux';
import { TReducerRootState } from '../redux/types';
import { selectorIsLoggedIn } from '../redux/selectors';

const useAuth = () => {
    return useSelector<TReducerRootState, boolean>(selectorIsLoggedIn);
};

export default useAuth;
